module.exports = __webpack_public_path__ + "static/media/Hercules_logo.0032ff88.png";